import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  CalendarInputComponent,
  SelectInputComponent,
} from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshorePositionAndWeatherEvents,
  OffshorePositionAndWeatherFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { TIMEZONE_SELECT_OPTIONS } from '@navstation-portal/shared/util/time';

@Component({
  selector: 're-observation',
  templateUrl: './observation.component.html',
  styleUrl: './observation.component.css',
  imports: [FormsModule, CalendarInputComponent, SelectInputComponent],
})
export class ObservationComponent extends AbstractStoreConnectedSectionComponent {
  timezoneOptions = TIMEZONE_SELECT_OPTIONS;
  tabId = 'positionAndWeather';
  sectionId = 'observation';
  events = injectDispatch(offshorePositionAndWeatherEvents);
  positionAndWeatherStore = inject(OffshorePositionAndWeatherFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
